/**
 * @param  {Object} paramObj
 * @return {string}
 */
export const generateQueryParams = (paramObj = {}) => {
  return Object.keys(paramObj)
    .filter(key => paramObj[key] !== undefined)
    .map(param => {
      const paramValue = paramObj[param];

      // Handle case if there are nested param values (ie. search params)
      if (
        paramValue !== null &&
        typeof paramValue !== 'string' &&
        !Array.isArray(paramValue) &&
        Object.keys(paramValue).length
      ) {
        return Object.keys(paramValue)
          .filter(key => paramValue[key] !== undefined)
          .map(
            nestedParam =>
              `${encodeURIComponent(nestedParam)}=${paramValue[nestedParam]}`,
          )
          .join('&');
      }

      return `${encodeURIComponent(param)}=${encodeURIComponent(paramValue)}`;
    })
    .join('&');
};

/**
 * Appends query parameters to the uri
 * @param  {string} uri
 * @param  {Object} queryObj
 * @return {string} encoded uri and encodedURIComponent params
 */
export const generateURIWithQueryParams = (uri, queryObj, isUriEncoded) => {
  const queryParams = generateQueryParams(queryObj);
  const encodedUri = (isUriEncoded ? uri : encodeURI(uri)).replace(/#/g, '%23');
  return queryParams ? `${encodedUri}?${queryParams}` : encodedUri;
};
